import { useState } from "react";
import { useHookstate } from "@hookstate/core";
import { useSelector } from "react-redux";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import { DailogMain, SiteSettingModalContainer } from "../MapStyled";
import {
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  FormControl,
  MenuItem,
  Select,
} from "@mui/material";
import Modal from "@mui/material/Modal";
import Box from "@mui/material/Box";
import { Area } from "pages/Map/MapStyled";
import { useTranslation } from "react-i18next";
import { CircleBtn, PopUpContainer } from "assets/css/globle";
import { SiteSetupAction } from "globalStore/globalStore";

const style1 = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  maxWidth: 444,
  bgcolor: "background.paper",
  width: "100%",
  background: "#FFFFFF",
  boxShadow: "0px 14px 100px 30px rgba(0, 0, 0, 0.3)",
  borderRadius: "4px",
  outline: "none",
};

const SiteSetupAreasPopups = ({
  sitesetupDialogBox,
  courseNameModel,
  courseNameHandleChange,
  holeNoModel,
  holeCount,
  courseTypeModel,
  courseTypeHandleChange,
  TempPolygon,
  verticesCount,
  siteSetupSaveActiveButton,
  cancelDialogOpen,
  deleteHoleArea,
  saveHoleArea,
  setSiteSetupSaveActiveButton,
  setHoleNoModel,
  areaModified
}) => {
  const { editSiteSetup, addSiteSetup } = useHookstate(SiteSetupAction);
  const { siteSettingsData } = useSelector((state) => state.commonReducers) || [];
  
  const { t } = useTranslation();

  const holeNoHandleChange = (e) => {
    setSiteSetupSaveActiveButton(true);
    setHoleNoModel(e.target.value);
    areaModified.set(true);
  };

  const [openDeletePopup, setOpenDeletePopup] = useState(false);

  return (
    <>
      <DailogMain
        style={{
          position: `${sitesetupDialogBox.position}`,
          top: `${sitesetupDialogBox.top}`,
          left: `${sitesetupDialogBox.left}`,
        }}
      >
        <SiteSettingModalContainer>
          <DialogTitle style={{ cursor: "move" }} id="draggable-dialog-title">
            {editSiteSetup.get() === true ? t("Edit_Site_Setting") : t("Add_Site_Setting")}
          </DialogTitle>

          <DialogContent>
            <DialogContentText>{t("Select_Hole_and_Area_Type")}</DialogContentText>
            <FormControl fullWidth>
              <Select
                labelId="demo-simple-select-label"
                id="demo-simple-select"
                value={courseNameModel}
                defaultValue={courseNameModel}
                onChange={(e) => courseNameHandleChange(e)}
              >
                {siteSettingsData &&
                  siteSettingsData?.Courses?.map((item) => (
                    <MenuItem key={item?.Number} value={item?.Number}>
                      {item?.Name}
                    </MenuItem>
                  ))}
              </Select>
            </FormControl>

            <FormControl>
              <Area>
                <Select
                  value={holeNoModel}
                  onChange={(e) => holeNoHandleChange(e)}
                  IconComponent={KeyboardArrowDownIcon}
                >
                  {holeCount &&
                    [...Array(holeCount)].map((elementInArray, index) => (
                      <MenuItem key={index} value={index + 1}> {index + 1} </MenuItem>
                    ))}
                </Select>
              </Area>
            </FormControl>

            <FormControl>
              <Select
                labelId="demo-simple-select-label"
                id="demo-simple-select"
                value={courseTypeModel}
                defaultValue={courseTypeModel}
                onChange={(e) => courseTypeHandleChange(e)}
              >
                <MenuItem value={0}>{t("Tee")}</MenuItem>
                <MenuItem value={1}>{t("Fairway")}</MenuItem>
                <MenuItem value={2}>{t("Green")}</MenuItem>
                <MenuItem value={3}>{t("Extents")}</MenuItem>
              </Select>
            </FormControl>
            <div>
              {t("Vertices")}: {" "}
              {editSiteSetup.get()
                ? verticesCount && verticesCount
                : TempPolygon && TempPolygon.length}
            </div>
          </DialogContent>
          <DialogActions>
            <CircleBtn
              disabled={!siteSetupSaveActiveButton}
              onClick={() => {
                saveHoleArea();
              }}
              className={siteSetupSaveActiveButton ? "active" : "disabled"}
            >
              {t("Save")}
            </CircleBtn>
            <CircleBtn 
              disabled={!siteSetupSaveActiveButton && addSiteSetup.get()}
              onClick={() => cancelDialogOpen("cancelModal")}>
              {t("Cancel")}
            </CircleBtn>
            {editSiteSetup.get() ? (
              <CircleBtn
                onClick={() => {
                  setOpenDeletePopup(true);
                }}
              >
                {t("Delete")}
              </CircleBtn>
            ) : null}
          </DialogActions>
        </SiteSettingModalContainer>
      </DailogMain>
      <Modal
        open={openDeletePopup}
        onClose={() => setOpenDeletePopup(false)}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
        maxWidth="sm"
      >
        <Box sx={style1}>
          <PopUpContainer>
            <h2>{t("Confirm")}</h2>
            <p>Delete this area?</p>

            <div className="action-btn">
              <button
                onClick={() => {
                  deleteHoleArea();
                }}
                className="primary"
              >
                {t("Yes")}
              </button>
              <button
                onClick={() => {
                  setOpenDeletePopup(false);
                }}
              >
                {t("No")}
              </button>
            </div>
          </PopUpContainer>
        </Box>
      </Modal>
    </>
  );
};

export default SiteSetupAreasPopups;
